<nav class="navbar-dark bg-dark fixed-bottom">
  <span class="navbar-text">
    &nbsp; V {{version}} (Server: {{serverVersion}})
  </span>
</nav>
